import React, { Component } from 'react';
import Button from 'react-bootstrap/Button';
import Form from 'react-bootstrap/Form';
import InputGroup from 'react-bootstrap/InputGroup';
import FormControl from 'react-bootstrap/FormControl';
import Alert from 'react-bootstrap/Alert';
import Modal from 'react-bootstrap/Modal';

// My components
import QAList from './qas/QAList';

var firebase = require('firebase/app');
require('firebase/auth');
require('firebase/firestore');

class SoftwareQA extends Component {
  constructor(props) {
    super(props);

    this.db = firebase.firestore();
    this.usersRef = this.db.collection('user_accounts');
    this.ref = this.db
      .collection('software_pages')
      .doc(this.props.match.params.id);

    this.handleQaSubmit = this.handleQaSubmit.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.submitReply = this.submitReply.bind(this);
    this.getAddQAButton = this.getAddQAButton.bind(this);

    this.state = {
      accType: '',
      prodId: this.props.match.params.id,
      qaText: '',
      qaCreator: '',
      qaCreatorEmail: '', // also the current user email
      qas: [],
      userQas: [],
      showModal: false,
      showAlert: [],
      alertText: [],
      searchCat1: true,
      searchCat2: true,
      searchCat3: true,
      searchCat4: true,
      pageRef: this.db
        .collection('software_pages')
        .doc(this.props.match.params.id),
      loggedIn: true,
    };
  }

  componentDidMount() {
    let _this = this;
    firebase.auth().onAuthStateChanged(function (user) {
      if (user) {
        _this.setState({
          qaCreator: user.displayName,
          qaCreatorEmail: user.email,
          accType: user.photoURL,
          loggedIn: true,
        });
        _this.usersRef
          .doc(user.email)
          .get()
          .then(doc => {
            if (doc.exists) {
              let docData = doc.data();
              _this.setState({ userQas: docData.qas });
            }
            // Load in all the current qas
            let _qas = [];
            _this.ref
              .collection('qas')
              .get()
              .then(query => {
                query.forEach(doc => {
                  _qas = _qas.concat(doc.data());
                });
                // Always udpate state in THEN after the data has been loaded
                _this.setState({ qas: _qas });
                console.log('State QAS');
                console.log(_this.state.qas);
              });
          });
      } else {
        // NO user exists
        // TODO: Add to redirect page
        _this.setState({ loggedIn: false });
      }
    });
  }

  handleQaSubmit(event) {
    event.preventDefault();
    let alertNeeded = false,
      alerts = [];

    const form = event.currentTarget;
    if (form.checkValidity() === false) {
      console.log('Form not valid!');
      event.stopPropogation();
      alertNeeded = true;
      alerts = alerts.concat('Please make sure all the inputs are filled');
      return;
    }

    // Good to go, create qa

    const newRef = this.ref.collection('qas').doc();

    let qaModel = {
      qaId: newRef.id,
      qaText: this.state.qaText,
      qaCreator: this.state.qaCreator,
      qaCreatorEmail: this.state.qaCreatorEmail,
      qaAnswered: false,
      devAnswered: false,
      userLikes: [],
      softies: 0,
    };

    let _this = this;

    newRef
      .set(qaModel)
      .then(resut => {
        // Then add the reviews to the user's review list
        _this.usersRef
          .doc(_this.state.qaCreatorEmail)
          .update({
            qas: _this.state.userQas.concat(
              _this.state.prodId + '/' + newRef.id
            ),
          })
          .then(result => {
            // Hide the model
            _this.setState({
              showModal: false,
              reviews: _this.state.qas.concat(qaModel),
            });
            window.location.reload();
          });
      })
      .catch(err => console.log('Error in posting qa: ', err));

    if (alertNeeded) {
      this.setState({ showAlert: true, alertText: alerts });
    }
  }

  submitReply = (qaId, replyText, devReply) => {
    const newRef = this.ref
      .collection('qas')
      .doc(qaId)
      .collection('replies')
      .doc();

    let replyModel = {
      replyId: newRef.id,
      replyText,
      replyCreator: this.state.qaCreator,
      replyCreatorEmail: this.state.qaCreatorEmail,
      devReply: devReply,
      corrReply: true,
      softies: 0,
      userLikes: [],
    };
    newRef
      .set(replyModel)
      .then(resut => {
        // Reply successfully submitted
      })
      .catch(err => console.log('Error in posting qa: ', err));
    return replyModel;
  };

  handleChange(event) {
    this.setState({
      [event.target.name]: event.target.value,
      showAlert: false,
    });
  }

  showInvalidAlert() {
    if (this.state.showAlert) {
      return (
        <Alert variant="warning">
          <Alert.Heading> Please fix the following problems: </Alert.Heading>
          <ul>
            {this.state.alertText.map(alertText => (
              <li> {alertText} </li>
            ))}
          </ul>
        </Alert>
      );
    } else {
      return <div></div>;
    }
  }

  getAddQAButton() {
    if (!this.state.loggedIn)
      return (
        <Alert variant="danger">
          {' '}
          You need to be logged in to post a review!{' '}
        </Alert>
      );
    return this.state.accType === 'user' ? (
      <Button
        variant="link"
        style={{ margin: '0px 0px 5px -8px' }}
        onClick={() => this.setState({ showModal: true })}
      >
        Add your own QA!
      </Button>
    ) : (
      <div></div>
    );
  }
  render() {
    return (
      <div className="container">
        <this.getAddQAButton />
        <Alert variant={'warning'}>
          Product QAs
        </Alert>

        <QAList
          softQaList={this.state.qas}
          submitReply={this.submitReply}
          prodId={this.state.prodId}
          userEmail={this.state.qaCreatorEmail}
          devAccount={this.state.accType === 'developer'}
          loggedIn={this.state.loggedIn}
        />

        <Modal
          size="lg"
          centered
          show={this.state.showModal}
          onHide={() => this.setState({ showModal: false })}
        >
          <Modal.Header closeButton>
            <Modal.Title>Ask a question</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Form onSubmit={this.handleQaSubmit}>
              <Form.Group controlId="enterQuestion">
                <Form.Control
                  maxLength="150"
                  name="qaText"
                  onChange={this.handleChange}
                  type="text"
                  placeholder="Ex: how do we .... ?"
                />
                <Form.Text
                  required
                  className="text-muted"
                  style={{ margin: '0px 0px 0px 8px' }}
                >
                  Try to be as specific as possible about what you want to know
                  to help others answer your question.
                </Form.Text>
              </Form.Group>

              <Modal.Footer>
                <Button
                  variant="secondary"
                  onClick={() => this.setState({ showModal: false })}
                >
                  Close
                </Button>
                <Button variant="primary" type="submit">
                  Create QA
                </Button>
              </Modal.Footer>
            </Form>
          </Modal.Body>
        </Modal>
      </div>
    );
  }
}

export default SoftwareQA;
